import { Helmet } from "react-helmet"
import { ContactForm } from "../../specific_components/contact_us/contact_us"

export const ContactUs = () => {
    return (
        <div >
            <div className="landing_images_4 landing_center" id="site_cover_image">
                <Helmet>
                    <title>DGA | Contact Us</title>
                </Helmet>
                <div className="company_details">
                    <div className="company_name smaller_company_name" id="company_name">
                        CONTACT US
                    </div>
                    <div className="tag_line">
                        Tell us anything...literally
                    </div>
                </div>
                <div className="navigation_on_home_container">
                </div> 
            </div>
                <div className="packages_main middle_component" style={{marginTop:'0px'}}>
                    <ContactForm />
                </div>
        </div>
    )
}